export enum Features {
  Preferences,
  DecisionSupportSystem,
}
